import { default as JsonEditorOnline, JSONEditorOptions } from 'jsoneditor';
import { DigitalObject } from '@cnri/doip-client';

export class FullDigitalObjectViewer {
    private readonly editor: JsonEditorOnline;

    constructor(containerDiv: JQuery, digitalObject: DigitalObject) {
        const cordraObjectDiv = $('<div class="col-md-12 nopadding"></div>');
        containerDiv.append(cordraObjectDiv);

        const attributesDiv = $(
            '<div style="height: 500px; display:block; width:100%;"></div>'
        );
        cordraObjectDiv.append(attributesDiv);

        const options = {
            ace,
            theme: "ace/theme/textmate",
            mode: "code",
            modes: ["code", "tree"], // allowed modes
            onError(err: unknown) {
                console.error(err);
            }
        } as JSONEditorOptions;
        this.editor = new JsonEditorOnline(attributesDiv[0], options, digitalObject);
        APP.disableJsonEditorOnline(this.editor);
    }
}
